// plugins/the-weather-company/utilities/layer-creation.utils.ts

import { TwcTime } from '../twc-time';
import { TwcProduct } from '../twc-products';
import { ExtendedMap } from '@jeppesen-foreflight/jmkw-types';
import { initialFlightLevel, initialTime } from '../twc.mixin';

/**
 * Gets the product ID for a selected flight level
 */
export const getProductIdForFlightLevel = (
  twcProduct: TwcProduct,
  flightLevel: string
): string => {
  return (
    twcProduct.flightLevelProductIds[flightLevel] ?? twcProduct.defaultProductId
  );
};

/**
 * Creates initial layer parameters from TWC data
 */
export const createInitialLayerParams = (
  twcProduct: TwcProduct,
  timeMap: ExtendedMap<TwcTime>,
  flightLevelValues: string[]
) => {
  return {
    id: twcProduct.id,
    zOrder: twcProduct.zOrder,
    flightLevelValues,
    label: twcProduct.label,
    selectedFlightLevel: initialFlightLevel(flightLevelValues),
    timeMap,
    selectedTime: initialTime(timeMap)
  };
};
